function setCookie(cname, cvalue, exdays) {
	let d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	let expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;secure";
}
function getCookie(cname) {
	let name = cname + "=";
	let ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}
function deteteCookie(cname) {
	document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

function documentReady(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

function showElement(elContext) {
    var el = document.querySelector(elContext);
    if (el) {
        el.style.display = 'block';
    }
}

function lockscreen(action, _opacity){
    let overlay = document.querySelector('#pageoverlay-top');
    overlay.style.opacity = _opacity;
    if(action == "unlock"){
        setTimeout(function(){
            overlay.classList.remove('is-visible');
        }, 500);
    }
    else{
        overlay.classList.add('is-visible');
    }
}

function getLoginApiToken() {
    return new Promise((resolve, reject) => {
        var in60Minutes = 1 / 24;
        var cntoken = "apitoken",
            cntoken_customer = "apitoken_customerid",
            cnteam = "dashboard_teamid",
            cnteam_customer = "dashboard_teamid_customerid";
        var cvtoken = getCookie(cntoken),
            cvtoken_customer = parseInt(getCookie(cntoken_customer)),
            cvteam = parseInt(getCookie(cnteam)),
            cvteam_customer = parseInt(getCookie(cnteam_customer));
        if (cvteam) {
            if (!cvteam_customer) {
                setCookie(cnteam_customer, ShopifyCustomerId, 1);
            } else if (cvteam_customer !== ShopifyCustomerId) { // case: Login Multipass
                console.log(`[ get-login-api-token ] cvteam = ${cvteam}, cvteam-customer = ${cvteam_customer}, customer-id-shopify = ${ShopifyCustomerId}`);
                //deteteCookie(cnteam);
                deteteCookie(cnteam_customer);
            }
        }
        if (ShopifyCustomerId == 0) {
            deteteCookie(cntoken);
            deteteCookie(cntoken_customer);
            //deteteCookie(cnteam);
            deteteCookie(cnteam_customer);
            resolve(""); return;
        }
        if (cvtoken) {
            if (!cvtoken_customer) {
                setCookie(cntoken_customer, ShopifyCustomerId, { expires: in60Minutes, path: '/', secure: true });
            } else if (cvtoken_customer !== ShopifyCustomerId) { // case: Login Multipass
                console.log(`[ get-login-api-token ] cvtoken = ${cvtoken}, cvtoken-customer = ${cvtoken_customer}, customer-id-shopify = ${ShopifyCustomerId}`);
                deteteCookie(cntoken); cvtoken = "";
                deteteCookie(cntoken_customer); cvtoken_customer = 0;
            }

            if (cvtoken.startsWith('"')) {
                cvtoken = JSON.parse(cvtoken);
            }
            if (cvtoken) {
                resolve(cvtoken); return;
            }
        }
        deteteCookie(cntoken);
        deteteCookie(cntoken_customer);
        //deteteCookie(cnteam);
        deteteCookie(cnteam_customer);
        var _data = { "cusid": ShopifyCustomerId.toString(), "secretkey": ShopifyCustomerKey };
        var _url = SEEndpointURL + 'api/token/account?key=' + Math.random();
        fetch(_url, { method: 'POST', headers: { 'Content-Type': 'application/json', }, body: JSON.stringify(_data), })
            .then(
                function(response) {
                    if (response.status !== 200) {
                        console.log('Looks like there was a problem with apitoken-generator(). Status Code: ' + response.status);
                        resolve("");
                        return;
                    }
                    response.json().then(function(data) {
                        if (data != null && data != "") {
                            setCookie(cntoken, data, 1/24);
                            resolve(data);
                        } else
                            resolve("");
                    });
                }
            )
            .catch(reject);
    });
}

function getAccountListSwitcherSplashPage(ShopifyCustomerId) {
    getLoginApiToken()
        .then(my_token => {
            if (my_token != "") {
                //SWIMOUTLET-53060 Account Switcher Redesign: Create Splash Page
                var teamaccountlineitem = '' +
                    '                            <div class="team-switcher-acc-profile">' +
                    '                              <div class="acc-profile-thumb">' +
                    '                                <img src="https://cdn.shopify.com/s/files/1/0248/3024/6994/files/generic-team-avatar.svg?v=1656556096">' +
                    '                              </div>' +
                    '                            </div>' +
                    '                            <div class="team-switcher-acc-name">' +
                    '                              <div class="team-switcher-fullname"></div>' +
                    '                              <div class="team-switcher-link"><a href="#" class="ga4-tracking-button" data-label="switcher-account">Manage Your Team Account</a></div>' +
                    '                            </div>' +
                    '';

                //get list team account
                var myData = {
                    'ShopifyCustomerID': ShopifyCustomerId
                };
                var url = SEEndpointURL + 'api/teamstore/dashboard/list?key=' + Math.random();
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'apitoken': my_token,
                    },
                    body: JSON.stringify(myData),
                })
                    .then(
                        function (response) {
                            response.json().then(function (data) {
                                if (data.Data.items.length > 0) {
                                    data.Data.items.forEach(function (p) {

                                        //get logo team path
                                        var logoTeamPath = "";
                                        if (p.teamlogo) {
                                            logoTeamPath = "https://photos.cdn-outlet.com/photos/Affiliate_StoreFront/" + p.teamlogo;
                                        }

                                        //render team account
                                        var parserTeamlLine = new DOMParser();
                                        var accountTeamType = "teamaccount";
                                        var htmlTeamAccountLine = parserTeamlLine.parseFromString(teamaccountlineitem, 'text/html');
                                        htmlTeamAccountLine.querySelector("div.team-switcher-fullname").innerHTML = p.teamname;
                                        htmlTeamAccountLine.querySelector("div.team-switcher-link > a").setAttribute("href", "javascript:changeAccountSwitcherSplashPage('" + p.teamid + "','" + accountTeamType + "', '" + (p.teamrole == "Super Admin" ? "s" : "a") + "');");
                                        if (logoTeamPath) {
                                            htmlTeamAccountLine.querySelector("div.acc-profile-thumb > img").setAttribute("src", logoTeamPath);
                                        }
                                        var HTMLTeamAccountlineItem = htmlTeamAccountLine.body.innerHTML;
                                        var listTeamAccountElement = document.querySelectorAll("div.splash-page-igroup-row.splash-page-igroup-acc");
                                        listTeamAccountElement.forEach(itemTeamAccountElement => {
                                            var myDivItem = document.createElement("div");
                                            myDivItem.className = 'team-switcher-acc-row';
                                            myDivItem.innerHTML = HTMLTeamAccountlineItem;
                                            itemTeamAccountElement.appendChild(myDivItem);
                                        });
                                    });
                                }
                            });
                        }
                    )
                    .catch(function (err) {
                        console.log('Fetch Error :-S', err);
                    });
            }
        }).catch(err => {
            console.log("Error when getting API key of getAccountListSwitcherSplashPage() in se-switcher-splash-page.js" + err);
        });
}

function changeAccountSwitcherSplashPage(accountID, accountType, accountRole) {
    getLoginApiToken()
        .then(my_token => {
            if (my_token != "") {
                showElement('.so-loading');
                lockscreen("", 0);
                setCookie("dashboard_teamid", accountID, 1);
                //set cookie frm for ticket SWIMOUTLET-60656
                //SO-70565-match the session-length expiry used everywhere else frm is written
                if (!getCookie("frm")) {
                    setCookie("frm", JSON.stringify({i: ShopifyCustomerId, r: accountRole}), 30);
                }
                else
                {
                    setCookie("frm", JSON.stringify({i: JSON.parse(getCookie("frm")).i, r: accountRole}), 30);
                }
                var shopifyCustomerId_personal = 0;
                if (accountType == "teamaccount") {
                    shopifyCustomerId_personal = JSON.parse(getCookie("frm")).i;
                }
                var origin = window.location.origin;
                var intendedDestination = sessionStorage.getItem('intended_destination');
                var returnToUrl = accountType == "teamaccount" ? origin + "/account?view=team-dashboard" : origin + "/account";
                // Honor intended destination from Start Your Order (customize editor)
                // and from login.liquid (account views). Supports both relative paths
                // and absolute URLs.
                if (intendedDestination) {
                    returnToUrl = intendedDestination.indexOf('http') === 0
                        ? intendedDestination
                        : origin + intendedDestination;
                }
                var myData = {
                    'accountID': accountID,
                    'accountType': accountType,
                    'return_to': returnToUrl,
                    'shopifyCustomerId': ShopifyCustomerId,
                    'shopifyCustomerId_personal': shopifyCustomerId_personal
                };
                var url = SEEndpointURL + 'api/customer/multipass/storefrontaccountswitcher?key=' + Math.random();
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'apitoken': my_token
                    },
                    body: JSON.stringify(myData),
                })
                    .then(
                        function (response) {
                            response.json().then(function (data) {
                                if (data.Data) {
                                    var origin = window.location.origin;
                                    var _uri = origin + "/account/login/multipass/" + data.Data;
                                    setTimeout(function () {
                                        window.location.href = _uri;
                                        if (accountType == "teamaccount") {
                                            setCookie("isRedirectToTeamDashBoardPage", "loaded", 1);
                                            if (intendedDestination) {
                                                sessionStorage.removeItem('intended_destination');
                                            } else {
                                                //SWIMOUTLET-53640
                                                let hostname_previouspage = document.referrer.match(/:\/\/(.[^/]+)/)[1];
                                                let hostname_currentpage = window.location.hostname;
                                                if (hostname_previouspage == hostname_currentpage) {
                                                    if (document.referrer.replace(/^[^:]+:\/\/[^/]+/, '').replace(/#.*/, '') != '/') // check if previous page has pathname
                                                    {
                                                        setCookie("previousPageAfterLoginTeamAccount", document.referrer, 1);
                                                    }
                                                }
                                            }
                                        } else if (intendedDestination) {
                                            sessionStorage.removeItem('intended_destination');
                                        }
                                    }, 2500);
                                }
                            });
                        }
                    )
                    .catch(function (err) {
                        console.log('Fetch Error :-S', err);
                    });
            }
        }).catch(err => {
            console.log("Error when getting API key of changeAccountSwitcherSplashPage() in se-switcher-splash-page.js" + err);
        });
}

function resolveIntendedDestinationUrl() {
    var intendedDestination = sessionStorage.getItem('intended_destination');
    if (!intendedDestination) return null;
    if (intendedDestination.indexOf('http') === 0) return intendedDestination;
    return window.location.origin + intendedDestination;
}

/**
 * Personal account row links to /account by default. When Start Your Order
 * (or another flow) stored an intended_destination, point that link there
 * so choosing personal account returns the customer to the design editor.
 */
function wirePersonalAccountIntendedDestination() {
    var intendedUrl = resolveIntendedDestinationUrl();
    if (!intendedUrl) return;

    var personalLinks = document.querySelectorAll(
        '.splash-page-igroup-acc .team-switcher-acc-row .team-switcher-link a[href="/account"]'
    );
    personalLinks.forEach(function (link) {
        link.setAttribute('href', intendedUrl);
        link.addEventListener('click', function () {
            sessionStorage.removeItem('intended_destination');
        });
    });
}

documentReady(function() {
    getAccountListSwitcherSplashPage(ShopifyCustomerId);
    wirePersonalAccountIntendedDestination();
});
